var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row justify-content-center align-items-center flex-nowrap"},[_vm._t("default"),(_vm.locked)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: _vm.iconTooltip,
      delay: 100,
      placement: 'top',
      container: 'body',
      trigger: 'click hover',
    }),expression:"{\n      content: iconTooltip,\n      delay: 100,\n      placement: 'top',\n      container: 'body',\n      trigger: 'click hover',\n    }"}],staticClass:"d-flex flex-row justify-content-center align-items-center lock-icon"},[_c('i',{class:_vm.iconClass})]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }